import { combineEpics } from "redux-observable";

import { fetchLoginEpic } from "../../controller/redux/login-reducers";
const rootEpic = combineEpics(fetchLoginEpic);

export default rootEpic;
